const style = {
  margin: 'normal',
  passwordType: 'password',
} as const;

export default style;
